import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=afd419c0&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"
import style0 from "./Errors.vue?vue&type=style&index=0&id=afd419c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports